import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addLiveVideoRequest, resetLiveVideoStatus } from '../../slice/liveVideoSlice';
import { toast } from 'react-toastify';

const AddLiveVideo = () => {
    const [uploadType, setUploadType] = useState('youtube'); // 'youtube' or 'file'
    const [formData, setFormData] = useState({
        name: '',
        youtube_url: '',
        status: 'active'
    });
    const [videoFile, setVideoFile] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { success, loading, error } = useSelector((state) => state.liveVideo);

    useEffect(() => {
        if (success) {
            toast.success("Video added successfully!");
            dispatch(resetLiveVideoStatus());
            navigate('/live-video');
        }
        if (error) {
            toast.error(error);
            dispatch(resetLiveVideoStatus());
        }
    }, [success, error, navigate, dispatch]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.name.trim()) return toast.error("Please enter video name");

        const data = new FormData();
        data.append('name', formData.name.trim());
        data.append('status', formData.status);

        if (uploadType === 'youtube') {
            if (!formData.youtube_url) return toast.error("Please enter YouTube URL");
            data.append('youtube_url', formData.youtube_url);
        } else {
            if (!videoFile) return toast.error("Please select a video file");
            data.append('video_file', videoFile);
        }

        dispatch(addLiveVideoRequest(data));
    };

    return (
        <div className="container-fluid px-4 py-4">
            <div className="card shadow border-0">
                <div className="card-header bg-primary text-white py-3">
                    <h5 className="mb-0">Add New Live Video</h5>
                </div>
                <div className="card-body p-4">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label htmlFor="name" className="adminlables">Video Name *</label>
                            <input
                                type="text" id="name" className="form-control"
                                placeholder="e.g. Live Opening Ceremony"
                                value={formData.name || ''}
                                onChange={(e) => setFormData({...formData, name: e.target.value})}
                                required
                            />
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-12">
                                <span className="adminlables mb-2 d-block">Select Upload Method</span>
                                <div className="btn-group w-100" role="group">
                                    <label className={`btn ${uploadType === 'youtube' ? 'btn-primary' : 'btn-outline-primary'}`}>
                                        <input 
                                            type="radio" className="btn-check" name="uploadTypeSelect"
                                            checked={uploadType === 'youtube'} onChange={() => setUploadType('youtube')} 
                                        />
                                        YouTube Link
                                    </label>

                                    <label className={`btn ${uploadType === 'file' ? 'btn-primary' : 'btn-outline-primary'}`}>
                                        <input 
                                            type="radio" className="btn-check" name="uploadTypeSelect"
                                            checked={uploadType === 'file'} onChange={() => setUploadType('file')} 
                                        />
                                        Upload Video File
                                    </label>
                                </div>
                            </div>
                        </div>

                        {uploadType === 'youtube' ? (
                            <div className="mb-4 animate__animated animate__fadeIn">
                                <label htmlFor="youtube_url" className="adminlables">YouTube URL</label>
                                <input 
                                    type="text" id="youtube_url" className="form-control" 
                                    placeholder="https://www.youtube.com/watch?v=..."
                                    value={formData.youtube_url || ''}
                                    onChange={(e) => setFormData({...formData, youtube_url: e.target.value})}
                                />
                                <small className="text-muted">Enter the full YouTube video link.</small>
                            </div>
                        ) : (
                            <div className="mb-4 animate__animated animate__fadeIn">
                                <label htmlFor="video_file" className="adminlables">Video File</label>
                                <input 
                                    type="file" id="video_file" className="form-control filebg" 
                                    accept="video/*"
                                    onChange={(e) => setVideoFile(e.target.files[0])}
                                />
                                <small className="text-muted">Supported formats: MP4, MKV, WebM.</small>
                            </div>
                        )}

                        <div className="mb-4">
                            <label htmlFor="status" className="adminlables">Status</label>
                            <select 
                                id="status" className="form-control"
                                value={formData.status || 'active'}
                                onChange={(e) => setFormData({...formData, status: e.target.value})}
                            >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        </div>

                        <div className="d-flex justify-content-end gap-3 mt-5">
                            <button type="button" className="btn btn-light px-4" onClick={() => navigate('/live-video')}>Cancel</button>
                            <button type="submit" className="btn btn-primary px-5" disabled={loading}>
                                {loading ? 'Saving...' : 'Save Video'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddLiveVideo;
